export default {
  title: "Rep"
  , form: {
    code: {
      label: "Clave REP"
      , th: "Clave REP"
    }
    , nombre: {
      label: "Nombre"
      , th: "Nombre"
    }
    , apellido: {
      label: "Apellido"
      , th: "Apellido"
    }
    , tipo: {
      label: "Tipo"
      , th: "Tipo"
    }
    , vendor: {
      label: "Vendor"
      , th: "Vendor"
    }
  }
  , errors: {
    BD5004: { text: "Ocurrió un error en el catálogo de Rep" }
    , WS5004: { text: "Ocurrió un error en el catálogo de Rep" }
    , JS5004: { text: "Ocurrió un error en el catálogo de Rep" }
    , CR5004: { text: "Ocurrió un error en el catálogo de Rep" }
    , UK_Rep: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/rep.js